// import Footer from './footer.vue';
import Footer from './footerNew.vue';

Footer.install = (Vue) => {
  Vue.component(Footer.name, Footer);
};

export default Footer;
